import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';

// This endpoint is similar to `readWorkspacesByOrganization` but returns only the `settings` object.
export const readWorkspacesSettingsByOrganization = async <
  T extends Record<string, unknown>,
>({
  organizationId,
  headers,
  domain,
  query,
  signal,
}: FetchRequestArgs & {
  organizationId: string;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    domain,
    endpoint: `/v2/messaging/organization/${organizationId}/workspaces/settings`,
    headers,
    query,
    signal,
  });
